"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postConstruct = void 0;
var metadata_1 = require("../class/metadata");
/** run method after create instance */
function postConstruct() {
    return function (target, key) {
        (0, metadata_1.getMetadata)(target.constructor).postConstruct.push({ key: key });
    };
}
exports.postConstruct = postConstruct;
//# sourceMappingURL=postConstruct.js.map